const PATIENT_RECORD_QUERY_PARAMS = ['patient', 'patients'];

export function hasPatientRecordQueryParam(search = window.location.search) {
  const params = new URLSearchParams(search || '');

  return PATIENT_RECORD_QUERY_PARAMS.some((name) => (
    params.get(name)?.toLowerCase() === 'true'
  ));
}

export function isSentPatientRecord({
  currentPage,
  currentTransmission,
  search = window.location.search,
  receiverType = null,
  treatMissingReceiverTypeAsPatient = false,
} = {}) {
  return currentTransmission?.patient === true
    || (
      currentPage === 'sent'
      && (hasPatientRecordQueryParam(search) || (treatMissingReceiverTypeAsPatient && !receiverType))
    );
}
